import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../MiniStoreContexts/MiniStoreThemeContext";
import CheckoutSummary from "../../Components/MiniStore/CheckoutComponents/CheckoutSummary";
import CartItem from "./MsCart/CartItem";
import { CartContext } from "../../contexts/MiniStore/CartContext";
import { Link, useNavigate } from "react-router-dom";
import { FaMinus, FaPlus } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { checkApi } from "../../DataApi/onboarding/checkApi";
import { checkoutFormValidationSchema } from "../../utilities/Validation Schema/checkoutFormValidation";
import { useSession } from "../../authentications/SessionContext";
import { enqueueSnackbar } from "notistack";
import { updateAddress } from "../../DataApi/miniStore/updateAddress";
import { createAddress } from "../../DataApi/miniStore/createAddress";
import { newCheckoutFormValidationSchema } from "../../utilities/Validation Schema/newCheckoutFormValidation";
import AddressComponent from "../../Components/MiniStore/CheckoutComponents/addressComponent";
import { getToken } from "../../DataApi/miniStore/getToken";
import AuthenticatedCheckoutForm from "../../Components/MiniStore/CheckoutComponents/AuthenticatedCheckoutForm";
import { getConfirmSelectedShipping } from "../../DataApi/miniStore/getConfirmSelectedShipping";
import { getConfirmOrder } from "../../DataApi/miniStore/getConfirmOrder";
import { getAcquirers } from "../../DataApi/miniStore/getAcquirers";
import { getDeliveryRates } from "../../DataApi/miniStore/getDeliveryRates";
import { getUpdatedDeliveryRate } from "../../DataApi/miniStore/getUpdatedDeliveryRate";
import { MdAddBox } from "react-icons/md";

const MsCheckout = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  const {
    cart,
    updateQuantity,
    removeFromCart,
    currency,
    setShippingCost,
    setCartTax,
    setTotal,
    cartLoading,
  } = useContext(CartContext);
  const navigate = useNavigate();
  const [countriesOption, setCountriesOption] = useState([]);
  const [statesOption, setStatesOption] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const {
    authenticated,
    savedAddress,
    handleGetAddress,
    billingAddress,
    shippingAddresses,
  } = useSession();
  const [paymentAcquirers, setPaymentAcquirers] = useState([]);
  const [allAcquirers, setAllAcquirers] = useState([]);
  const [paymentType, setPaymentType] = useState(null);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [updatedDeliveryMethods, setUpdatedDeliveryMethods] = useState([]);
  const [deliveryType, setDeliveryType] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [isAddAddress, setIsAddAddress] = useState(false);
  const [isBilling, setIsBilling] = useState(false);
  const [selectedShipping, setSelectedShipping] = useState(
    shippingAddresses.length > 0 ? shippingAddresses[0] : {}
  );
  const newCheckoutFormInitialValues = {
    name: "",
    email: "",
    // company_name: "",
    phone_prefix: "968",
    phone: "",
    street: "",
    city: "",
    zip: "",
    state_id: "",
    country_id: 171,
  };
  const checkoutFormInitialValues = {
    billing_id: billingAddress?.id || null,
    billing_name: billingAddress?.name || "",
    billing_email: billingAddress?.email || "",
    billing_phone_prefix: "968",
    billing_phone: billingAddress?.phone || "",
    billing_company_name: billingAddress?.company || "",
    billing_vat: "",
    billing_street: billingAddress?.street || "",
    billing_city: billingAddress?.city || "",
    billing_state: billingAddress?.state_id || "",
    billing_state_name: billingAddress?.state || "",
    billing_zip: billingAddress?.zip || "",
    billing_country:
      billingAddress?.country_id || savedAddress?.country_id || 171,
    billing_country_name: billingAddress?.country || "",
    // Shipping Address Fields (Array for Multiple Shipping Addresses)
    shipping_addresses: shippingAddresses.map((shippingAddress) => ({
      shipping_id: shippingAddress?.id || null,
      shipping_name: shippingAddress?.name || billingAddress?.name,
      shipping_email: shippingAddress?.email || "",
      shipping_phone_prefix: "968",
      shipping_phone: shippingAddress?.phone || "",
      shipping_company_name: shippingAddress?.company || "",
      shipping_street: shippingAddress?.street || "",
      shipping_city: shippingAddress?.city || "",
      shipping_state: shippingAddress?.state_id || "",
      shipping_state_name: shippingAddress?.state || "",
      shipping_zip: shippingAddress?.zip || "",
      shipping_country: shippingAddress?.country_id || 171,
      shipping_country_name: shippingAddress?.country || "",
    })),
  };

  const toggleCollapse = () => {
    setCollapsed((prevState) => !prevState);
  };
  const handleSaveAddress = async (values, errors) => {
    // if (Object.keys(errors)?.length > 0) return;
    // console.log("selectedShipping, values", selectedShipping, values);

    let matchedAddress = null;

    if (values.billing_id === selectedShipping.id) {
      matchedAddress = {
        id: values.billing_id,
        ...Object.fromEntries(
          Object.entries(values).filter(([key]) => key.startsWith("billing_"))
        ),
      };
      matchedAddress = Object.fromEntries(
        Object.entries(matchedAddress).map(([key, value]) => [
          key.startsWith("billing_") ? key.replace("billing_", "") : key,
          value,
        ])
      );
      // console.log("matched billing address", matchedAddress);
    } else {
      matchedAddress = values.shipping_addresses.find(
        (addr) => addr.shipping_id === selectedShipping.id
      );

      if (matchedAddress) {
        matchedAddress = {
          id: matchedAddress.shipping_id,
          ...Object.fromEntries(
            Object.entries(matchedAddress).map(([key, value]) => [
              key.replace("shipping_", ""),
              value,
            ])
          ),
        };
      }
      // console.log("matched shipping address", matchedAddress);
    }

    if (!matchedAddress) {
      enqueueSnackbar("No matching address found!", { variant: "warning" });
      return;
    }
    try {
      const response = await updateAddress(matchedAddress);

      if (response) {
        setDisabled(true);
        enqueueSnackbar("Address updated successfully!", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar("Failed to update address!", { variant: "error" });
    }
    handleGetAddress({ partner_id: false });
  };
  const handleCreateAddress = async (values, errors) => {
    // console.log("in create address", values);
    // if (Object.keys(errors)?.length > 0) return;
    try {
      const tokenData = await getToken();
      if (!tokenData?.token) return;
      const token = tokenData.token;
      const endpoint = "/shop/confirm_order";
      const fullUrl = `${window.location.origin}${endpoint}`;
      const response = await createAddress({
        name: values?.name,
        email: values.email,
        phone: values?.phone_prefix + values?.phone,
        company_name: values?.company_name,
        street: values.street,
        city: values.city,
        zip: values.zip,
        state_id: values.state_id,
        country_id: values.country_id,
        csrf_token: token,
        submitted: 1,
        partner_id: -1,
        callback: fullUrl,
        field_required: "phone,name",
      });

      // if (response) {
      // console.log("create address api response", response);
      handleGetAddress({ partner_id: false });
      // console.log("check savedAddress after create address api", savedAddress);
      // setSavedAddress(response);
      // updateAddressInCart({ partner_id: response?.result?.new_partner_id });
      enqueueSnackbar("Address created successfully!", {
        variant: "success",
      });
      // }
    } catch (error) {
      enqueueSnackbar("Failed to update address!", { variant: "error" });
    }
  };
  const confirmSelectedShipping = async () => {
    try {
      if (!selectedShipping?.id) {
        enqueueSnackbar("No shipping address selected!", { variant: "error" });
        return;
      }
      const tokenData = await getToken();
      if (!tokenData?.token) return;
      const token = tokenData.token;
      const response = await getConfirmSelectedShipping({
        csrf_token: token,
        partner_id: selectedShipping?.id,
        xhr: 1,
      });

      if (response) {
        if (typeof response === "string" && response.includes("ok")) {
          // enqueueSnackbar("Shipping address set successfully!", {
          //   variant: "success",
          // });
          const confirmOrderResponse = await getConfirmOrder();
          if (confirmOrderResponse) {
            handleGetAcquirers();
          }
        } else {
          enqueueSnackbar("Failed to set shipping address!", {
            variant: "error",
          });
        }
      }
    } catch (error) {
      enqueueSnackbar("Failed to set shipping address!", { variant: "error" });
    }
  };
  const handleGetAcquirers = async () => {
    let acquirersResponse = await getAcquirers();
    // console.log("acquirersResponse", acquirersResponse);
    const deliveries = acquirersResponse?.result?.deliveries;
    const acquirers = acquirersResponse?.result?.acquirers;
    setDeliveryMethods(deliveries);

    // setPaymentAcquirers(acquirers);
    setAllAcquirers(acquirers);
  };
  const onClickPaymentType = (e, acquirer) => {
    e.preventDefault();
    setPaymentType(acquirer.id);
  };
  const onClickDeliveryType = async (e, id) => {
    if (e) e.preventDefault();
    setDeliveryType(id);
    const fondPaymentTypes = deliveryMethods.find(
      (delivery) => delivery.id === id
    );

    if (fondPaymentTypes && allAcquirers.length > 0) {
      const filtered = allAcquirers.filter((acquirer) =>
        fondPaymentTypes.payment_acquirer_ids.includes(acquirer.id)
      );
      setPaymentAcquirers(filtered);
    }

    try {
      let updatedDeliveryRateResponse = await getUpdatedDeliveryRate(
        String(id)
      );
      // console.log(
      //   "onClickDeliveryType updatedDeliveryRateResponse",
      //   updatedDeliveryRateResponse
      // );
      if (updatedDeliveryRateResponse) {
        const carrierId = updatedDeliveryRateResponse?.result?.carrier_id;
        const rawAmountDelivery =
          updatedDeliveryRateResponse?.result?.new_amount_delivery;
        const rawAmountTax =
          updatedDeliveryRateResponse?.result?.new_amount_tax;
        const rawAmountTotal =
          updatedDeliveryRateResponse?.result?.new_amount_total;

        const cleanAmountDelivery =
          rawAmountDelivery?.match(/>(\d+(\.\d+)?)</)?.[1] || "";
        const cleanAmountTax =
          rawAmountTax?.match(/>(\d+(\.\d+)?)</)?.[1] || "";
        const cleanAmountTotal =
          rawAmountTotal?.match(/>(\d+(\.\d+)?)</)?.[1] || "";
        // console.log(
        //   `Delivery Rate for Carrier ${carrierId}: ${cleanAmountDelivery}`
        // );
        // console.log(`Tax Rate for Carrier ${carrierId}: ${cleanAmountTax}`);
        // console.log(
        //   `Total Amount for Carrier ${carrierId}: ${cleanAmountTotal}`
        // );
        setCartTax(cleanAmountTax);
        setTotal(cleanAmountTotal);
        setShippingCost(cleanAmountDelivery);
        setUpdatedDeliveryMethods((prevMethods) => [
          ...prevMethods,
          {
            carrier_id: carrierId,
            new_amount_delivery: cleanAmountDelivery,
          },
        ]);
      } else {
        console.error(`Failed to fetch rate for carrier ${id}`);
      }
    } catch (err) {
      console.error(
        "Unexpected error while fetching updated delivery rates",
        err
      );
    }
  };
  const fetchAllDeliveryRates = async (deliveryMethods) => {
    if (!deliveryMethods?.length) return;
    // console.log("got the deliveryMethods..............", deliveryMethods);
    try {
      const results = await Promise.all(
        deliveryMethods.map((method) => getDeliveryRates(String(method.id)))
      );

      const updatedDeliveryMethods = results
        .map((response, index) => {
          const method = deliveryMethods[index];
          if (response) {
            const carrierId = response?.result?.carrier_id;
            const rawAmount = response?.result?.new_amount_delivery;

            const cleanAmount = rawAmount?.match(/>(\d+(\.\d+)?)</)?.[1] || "";

            // console.log(
            //   `Delivery Rate for Carrier ${carrierId}: ${cleanAmount}`
            // );

            setShippingCost(cleanAmount);
            return {
              carrier_id: carrierId,
              new_amount_delivery: cleanAmount,
            };
          } else {
            console.error(`Failed to fetch rate for carrier ${method.id}`);
            return null;
          }
        })
        .filter((item) => item !== null);
      setUpdatedDeliveryMethods(updatedDeliveryMethods);
    } catch (err) {
      console.error("Unexpected error while fetching delivery rates", err);
    }
  };
  const getStates = (value) => {
    checkApi({
      endpoint: "/onboarding/states",
      params: {
        country_id: value,
      },
    }).then((states) => {
      if (states?.result?.result?.length > 0) {
        const statesOp = states?.result?.result?.map((state) => ({
          label: state.name,
          value: state.id,
          zip: state.zip,
        }));
        setStatesOption(statesOp || []);
      }
    });
  };

  useEffect(() => {
    if (updatedDeliveryMethods?.length && !deliveryType) {
      // console.log(
      //   "got the updatedDeliveryMethods..............",
      //   updatedDeliveryMethods
      // );

      setDeliveryType(deliveryMethods[0]?.id);
      onClickDeliveryType(null, deliveryMethods?.[0]?.id);
    }
  }, [updatedDeliveryMethods, deliveryMethods, deliveryType]);
  useEffect(() => {
    if (deliveryMethods?.length) {
      // console.log("got the deliveryMethods..............", deliveryMethods);
      fetchAllDeliveryRates(deliveryMethods);
    }
  }, [deliveryMethods]);
  useEffect(() => {
    if (paymentAcquirers?.length) {
      // console.log("got the paymentAcquirers..............", paymentAcquirers);
      setPaymentType(paymentAcquirers[0].id);
    }
  }, [paymentAcquirers]);
  useEffect(() => {
    if (selectedShipping?.id) {
      confirmSelectedShipping();
    }
  }, [selectedShipping]);
  useEffect(() => {
    if (!cartLoading && cart.length === 0) {
      navigate("/mini-store/shop", { replace: true });
    }
  }, [cartLoading, cart, navigate]);
  useEffect(() => {
    if (paymentType) {
      // fetchPaymentToken();
    }
  }, [paymentType]);
  useEffect(() => {
    handleGetAddress({ partner_id: false });
    handleGetAcquirers();
    checkApi({ endpoint: "/onboarding/countries", params: {} }).then(
      (countries) => {
        const countriesOp = countries?.result?.result?.map((country) => ({
          label: country.name,
          value: country.id,
          phone_code: country.phone_code,
        }));

        setCountriesOption(countriesOp || []);
      }
    );
    if (updatedDeliveryMethods?.length) {
      // console.log(
      //   "got the updatedDeliveryMethods..............",
      //   updatedDeliveryMethods
      // );

      setDeliveryType(deliveryMethods[0].id);
    }
  }, []);
  // console.log("authenticated", authenticated);
  // console.log("billingAddress", billingAddress);
  // console.log("billingAddress?.country_id", billingAddress?.country_id);
  // console.log("isAddAddress", isAddAddress);
  // console.log("shippingAddresses", shippingAddresses);
  return (
    <CheckoutWrapper>
      <CheckoutTitle>Checkout</CheckoutTitle>
      <CheckoutInnerWrapper>
        <CheckoutDetailsWrapper theme={theme}>
          <OrderSummaryTitle onClick={toggleCollapse}>
            1. Order Summary {collapsed ? <FaPlus /> : <FaMinus />}
          </OrderSummaryTitle>
          <OrderSummaryContent collapsed={collapsed}>
            {cart.map((item, index) => (
              <CartItem
                key={index}
                item={item}
                id={item.id}
                quantity={item.quantity}
                theme={theme}
                checkout={true}
                removeFromCart={removeFromCart}
                onQuantityChange={(id, change) =>
                  updateQuantity({
                    productId: id,
                    qtyChange: change,
                  })
                }
              />
            ))}
          </OrderSummaryContent>
          {billingAddress &&
            billingAddress?.country_id &&
            Array.isArray(shippingAddresses) &&
            shippingAddresses?.filter(Boolean)?.length > 0 && (
              <AuthenticatedCheckoutForm
                checkoutFormInitialValues={checkoutFormInitialValues}
                checkoutFormValidationSchema={checkoutFormValidationSchema}
                handleSaveAddress={handleSaveAddress}
                selectedShipping={selectedShipping}
                setSelectedShipping={setSelectedShipping}
                disabled={disabled}
                setDisabled={setDisabled}
                isBilling={isBilling}
                setIsBilling={setIsBilling}
                setIsAddAddress={setIsAddAddress}
                theme={theme}
                statesOption={statesOption}
                countriesOption={countriesOption}
                getStates={getStates}
              />
            )}
          {(!billingAddress?.country_id ||
            billingAddress?.country_id === false ||
            isAddAddress) && (
            <AddressComponent
              theme={theme}
              countriesOption={countriesOption}
              statesOption={statesOption}
              getStates={getStates}
              handleCreateAddress={handleCreateAddress}
              newCheckoutFormInitialValues={newCheckoutFormInitialValues}
              newCheckoutFormValidationSchema={newCheckoutFormValidationSchema}
              billingAddress={billingAddress}
              shippingAddresses={shippingAddresses}
              selectedShipping={selectedShipping}
              setSelectedShipping={setSelectedShipping}
              disabled={disabled}
              setDisabled={setDisabled}
              isAddAddress={isAddAddress}
              setIsAddAddress={setIsAddAddress}
              setIsBilling={setIsBilling}
            />
          )}

          {!isAddAddress &&
            shippingAddresses?.length &&
            shippingAddresses?.[0].country_id && (
              <button
                type="button"
                className="d-flex justify-content-center align-items-center mt-2"
                onClick={() => {
                  setIsAddAddress(true);
                  setDisabled(true);
                  setIsBilling(false);
                }}
                style={{
                  background: `${theme.primaryColor.secondary}`,
                  color: `${theme.primaryColor.primary}`,
                  cursor: "pointer",
                  borderRadius: "0.15rem",
                  fontFamily: "Outfit, sans-serif",
                  minHeight: "58px",
                }}
              >
                <MdAddBox className="mx-1" /> Add an address
              </button>
            )}
          {Object.keys(selectedShipping)?.length > 0 ? (
            <>
              <ContactInfoTitle>
                {authenticated ? "4." : "3."} Choose a delivery method
              </ContactInfoTitle>
              <DeliveryToggleContainer>
                {Array.isArray(deliveryMethods) &&
                deliveryMethods.length > 0 ? (
                  deliveryMethods.map((delivery) => {
                    const deliveryRate = updatedDeliveryMethods?.find(
                      (item) => String(item.carrier_id) === String(delivery.id)
                    );

                    return (
                      <DeliveryButton
                        key={delivery.id}
                        theme={theme}
                        selected={deliveryType === delivery.id}
                        onClick={(e) => onClickDeliveryType(e, delivery.id)}
                      >
                        {delivery.name}
                        {deliveryType === delivery.id && (
                          <PillBadge theme={theme}>
                            {deliveryRate
                              ? currency +
                                " " +
                                deliveryRate.new_amount_delivery
                              : "OMR 0.000"}
                          </PillBadge>
                        )}
                      </DeliveryButton>
                    );
                  })
                ) : (
                  <p className="text-center w-100">
                    No delivery methods available
                  </p>
                )}
              </DeliveryToggleContainer>

              <ContactInfoTitle>
                {authenticated ? "5." : "4."} Pay with
              </ContactInfoTitle>
              <PaymentToggleContainer>
                {Array.isArray(paymentAcquirers) &&
                paymentAcquirers.length > 0 ? (
                  paymentAcquirers.map((acquirer) => {
                    const base64Image = acquirer.image_128
                      ? `data:image/png;base64,${acquirer.image_128}`
                      : null;

                    return (
                      <PaymentButton
                        key={acquirer.id}
                        theme={theme}
                        selected={paymentType === acquirer.id}
                        onClick={(e) => onClickPaymentType(e, acquirer)}
                      >
                        {base64Image && (
                          <PaymentIcon src={base64Image} alt={acquirer.name} />
                        )}
                        {acquirer.name}
                      </PaymentButton>
                    );
                  })
                ) : (
                  <p className="text-center w-100">
                    No payment methods available
                  </p>
                )}
              </PaymentToggleContainer>
            </>
          ) : shippingAddresses?.length &&
            shippingAddresses?.[0]?.country_id ? (
            <p className="text-center my-3">
              Select an address to get shipment and payment types!
            </p>
          ) : (
            <p className="text-center my-3">
              Add an address to get shipment and payment types!
            </p>
          )}
        </CheckoutDetailsWrapper>
        <CheckoutSummary
          paymentAcquirers={paymentAcquirers}
          theme={theme}
          deliveryType={deliveryType}
          paymentType={paymentType}
          isSelectedShipping={Object.keys(selectedShipping)?.length > 0}
        />
      </CheckoutInnerWrapper>
    </CheckoutWrapper>
  );
};

export default MsCheckout;

const DeliveryToggleContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 1.5rem 0rem;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const DeliveryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 0.15rem;
  border: 2px solid
    ${({ selected, theme }) => (selected ? theme.primaryColor.primary : "#fff")};
  color: #000;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
  img {
    width: 45px;
    height: 45px;
    object-fit: contain;
  }
  @media (max-width: 375px) {
    font-size: 14px;
  }
`;
const PaymentToggleContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 1.5rem 0rem;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const PaymentButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 0.15rem;
  border: 2px solid
    ${({ selected, theme }) => (selected ? theme.primaryColor.primary : "#fff")};
  color: #000;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
  img {
    width: 45px;
    height: 45px;
    object-fit: contain;
  }
  @media (max-width: 375px) {
    font-size: 14px;
  }
`;
const PaymentIcon = styled.img`
  width: 25px;
  height: 25px;
  object-fit: contain;
  @media (max-width: 375px) {
    width: 18px;
    height: 20px;
  }
`;
const PillBadge = styled.span`
  padding: 5px 10px;
  border-radius: 50px;
  background: ${({ theme }) => theme.primaryColor.primary};
  color: ${({ theme }) => theme.textColor.primary};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  @media (max-width: 375px) {
    font-size: 8px;
  }
`;
const CheckoutWrapper = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const CheckoutTitle = styled.div`
  font-family: Outfit, sans-serif;
  font-size: 28px;
  font-weight: 600;
  line-height: 29px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0px 60px 0px;
`;
const CheckoutInnerWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const CheckoutDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(70% - 10px);
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  padding: 1.5rem;
`;
const OrderSummaryTitle = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  align-item: center;
  justify-content: space-between;
  width: 100%;
  font-weight: bold;
  padding: 10px;
  font-size: 20px;
  border-bottom: 2px solid #9c9a9a;
  cursor: pointer;
  color: #666666;
  svg {
    color: #666666;
  }
`;
const OrderSummaryContent = styled.div`
  margin-top: 10px;
  max-height: ${({ collapsed }) =>
    collapsed ? "0" : "456px"}; // Max height when expanded
  opacity: ${({ collapsed }) =>
    collapsed ? "0" : "1"}; // Fade effect when collapsed
  overflow: ${({ collapsed }) =>
    collapsed ? "hidden" : "scroll"}; // Hide overflow content when collapsed
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out; // Animate max-height and opacity
`;
const ContactInfoTitle = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  font-weight: bold;
  padding: 10px;
  font-size: 20px;
  border-bottom: 2px solid #9c9a9a;
  color: #666666;
`;
const AddressToggleContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 1.5rem 0rem;
`;
const StyledButton = styled(Link)`
  font-family: Outfit, sans-serif;
  text-decoration: none;
  font-weight: bold;
  padding: 10px;
  font-size: 20px;
  color: ${({ theme }) => theme.primaryColor.primary};
  &:hover {
    color: ${({ theme }) => theme.primaryColor.secondary};
  }
`;

const ToggleWrapper = styled.label`
  display: flex;
  align-items: center;
  width: 50px;
  height: 25px;
  border-radius: 50px;
  background: ${({ theme }) => theme.backgroundColor.secondary};
  position: relative;
  cursor: pointer;
`;

const HiddenCheckbox = styled.input`
  display: none;
`;

const ToggleSlider = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50px;
  background: ${({ selected, theme }) =>
    selected ? theme.primaryColor.primary : theme.primaryColor.secondary};
  display: flex;
  align-items: center;
  justify-content: ${({ selected }) => (selected ? "flex-end" : "flex-start")};
  padding: 5px;
  transition: all 0.3s ease;
`;

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, addressType }) =>
    addressType ? theme.primaryColor.primary : theme.primaryColor.secondary};
`;

const EditButton = styled.button`
  margin-left: 1rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.primaryColor.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.primaryColor.secondary};
  }
`;
